var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5654_0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38892 21.2778H2.38892C1.99109 21.2778 1.60956 21.1197 1.32826 20.8384C1.04695 20.5571 0.888916 20.1756 0.888916 19.7778V3.27778C0.888916 2.87995 1.04695 2.49842 1.32826 2.21712C1.60956 1.93581 1.99109 1.77778 2.38892 1.77778H13.0179C13.4156 1.77813 13.7969 1.93639 14.0779 2.21778L16.9499 5.08878C17.0892 5.22813 17.1996 5.39356 17.275 5.57561C17.3503 5.75766 17.389 5.95276 17.3889 6.14978V7.77778",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13892 7.02778L11.3889 9.27778L9.13892 11.5278",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13892 7.02778L3.88892 9.27778L6.13892 11.5278",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17.25C11 17.9394 11.1358 18.6221 11.3996 19.2591C11.6635 19.896 12.0502 20.4748 12.5377 20.9623C13.0252 21.4498 13.604 21.8365 14.2409 22.1004C14.8779 22.3642 15.5606 22.5 16.25 22.5C16.9394 22.5 17.6221 22.3642 18.2591 22.1004C18.896 21.8365 19.4748 21.4498 19.9623 20.9623C20.4498 20.4748 20.8365 19.896 21.1004 19.2591C21.3642 18.6221 21.5 17.9394 21.5 17.25C21.5 16.5606 21.3642 15.8779 21.1004 15.2409C20.8365 14.604 20.4498 14.0252 19.9623 13.5377C19.4748 13.0502 18.896 12.6635 18.2591 12.3996C17.6221 12.1358 16.9394 12 16.25 12C15.5606 12 14.8779 12.1358 14.2409 12.3996C13.604 12.6635 13.0252 13.0502 12.5377 13.5377C12.0502 14.0252 11.6635 14.604 11.3996 15.2409C11.1358 15.8779 11 16.5606 11 17.25V17.25Z",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.389 24.2779L19.601 20.4909",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5654_0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFind);
export default __webpack_public_path__ + "static/media/find.3d0fd674a32cd2e444695da55972b052.svg";
export { ForwardRef as ReactComponent };